import React, { createContext, useState, useContext } from 'react';

const LanguageAnimationContext = createContext();

export const LanguageAnimationProvider = ({ children }) => {
    const [animate, setAnimate] = useState(false);

    const triggerAnimation = () => {
        setAnimate(true);
    };

    return (
        <LanguageAnimationContext.Provider value={{ animate, setAnimate, triggerAnimation }}>
            {children}
        </LanguageAnimationContext.Provider>
    );
};

export const useLanguageAnimation = () => useContext(LanguageAnimationContext);